export default {"src":"/_next/static/media/yellow-lines.48c85009.webp","height":480,"width":480,"blurWidth":0,"blurHeight":0};